"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _logger = require("@immediate_media/logger");

var logger = (0, _logger.createLogger)('fabric-api-clients');
var _default = logger;
exports["default"] = _default;